<template>
  <b-modal
    ref="modal"
    :title="title"
    centered body-class="p-3"
    no-close-on-backdrop
    no-close-on-esc
    size="lg"
  >

    <!-- <container class="mx-auto" fluid >
    </container> -->
    <div class="text-center" fluid>
      {{message}}
    </div>

    <template slot="modal-footer">
      <b-button variant="primary" @click="conferma">
        <font-awesome-icon icon="check"/> {{okLable}}
      </b-button>

      <b-button variant="outline-secondary" @click="annulla">
        <font-awesome-icon icon="redo-alt"/> {{koLabel}}
      </b-button>

      <b-button variant="outline-secondary" @click="close">
        <font-awesome-icon icon="times"/> {{closeLalabel}}
      </b-button>
    </template>

  </b-modal>
</template>

<script>
export default {
  name: 'RichiediConfermaModal',
  data () {
    return {
      title: 'Title',
      message: 'Message description',
      okLable: 'ok label',
      koLabel: 'ko label',
      closeLalabel: 'Chiudi'
    }
  },

  methods: {
    async open (confermaOptions) {
      // console.log('Verifica confermaOptions', confermaOptions)
      this.title = confermaOptions.title || this.title
      this.message = confermaOptions.message || this.message
      this.okLable = confermaOptions.okLable || this.okLable
      this.koLabel = confermaOptions.koLabel || this.koLabel
      this.closeLalabel = confermaOptions.closeLalabel || this.closeLalabel
      this.$refs.modal.show()
    },

    close () {
      this.$refs.modal.hide()
    },

    async conferma () {
      try {
        this.$refs.modal.hide()
        this.$emit('conferma', { conferma: true })
      } catch (err) {
        this.$ui.showError(err)
        // Se c'è qualsiasi tipo di problema nel caricamento della lista delle dichiarazioni esce comunque.
        this.$router.push({ name: 'home' })
      }
    },

    async annulla () {
      try {
        this.$refs.modal.hide()
        this.$emit('conferma', { conferma: false })
      } catch (err) {
        this.$ui.showError(err)
        // Se c'è qualsiasi tipo di problema nel caricamento della lista delle dichiarazioni esce comunque.
        this.$router.push({ name: 'home' })
      }
    }

  }
}
</script>
